<script setup>

const props = defineProps({
	imgUrl: String,
})

</script>

<template>
	<img class="image_min boxShadow" :src="props.imgUrl">
</template>

<style>
.image_min {
	border-width: 0;
	margin: 7px 0px 0 0;
	width: 72px;
	min-width: 65px;
}

.boxShadow {
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
	border-radius: 4px;
}
</style>
